import React, { useState, useEffect } from 'react';

import appService from '../../service/app.service';
import { ButtonUI, DialogUI, FormLabelUI, SelectUI } from '../Interface';

const DocRoleModify = ({
  hasPermission,
  selectedDoc,
  roleDocPermissions,
  roleId,
  setRoleDocPermissions,
  setRefreshPage,
  onHide,
  show,
}) => {
  const [permission, setPermission] = useState(hasPermission);
  const [canEdit, setCanEdit] = useState(true);
  const [canCopy, setCanCopy] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [canEmailSend, setCanEmailSend] = useState(false);

  useEffect(() => {
    setPermission(hasPermission);
    const findedPerm = roleDocPermissions.find((f) => f.documentTypeId === selectedDoc);
    const canEdit = findedPerm?.roleDocPermissions[0]?.canEdit ?? true;

    setCanEdit(canEdit);

    if (!canEdit) {
      setCanCopy(false);
      setCanDelete(false);
      setCanEmailSend(false);
    } else {
      setCanCopy(findedPerm?.roleDocPermissions[0]?.canCopy ?? false);
      setCanDelete(findedPerm?.roleDocPermissions[0]?.canDelete ?? false);
      setCanEmailSend(findedPerm?.roleDocPermissions[0]?.canEmailSend ?? false);
    }
  }, [selectedDoc]);

  useEffect(() => {
    if (!canEdit) {
      setCanCopy(false);
      setCanDelete(false);
      setCanEmailSend(false);
    }
  }, [canEdit]);

  const handleChangeRole = async () => {
    appService
      .updateDocPermission(roleId, selectedDoc, permission, canEdit, canCopy, canDelete, canEmailSend)
      .then(() => {
        const updatedDocList = roleDocPermissions.map((permission) =>
          permission.documentTypeId === selectedDoc ? { ...permission, hasPermission: permission } : permission
        );
        setRoleDocPermissions(updatedDocList);
        setRefreshPage((prev) => !prev);
        onHide();
      })
      .finally(() => {});
  };

  const options = [
    { value: true, label: 'Jogosult' },
    { value: false, label: 'Nem jogosult' },
  ];

  return (
    <DialogUI open={show} headerContent={'Jogosultság módosítás'} fullWidth>
      <div className="flex justify-center flex-wrap">
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={permission ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setPermission(value);
            }}
            option={options}
            label={<FormLabelUI text="Jogosultság beállítása" />}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canEdit ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanEdit(value);
            }}
            option={options}
            label={<FormLabelUI text="Szerkesztheti" />}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canCopy ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanCopy(value);
            }}
            option={options}
            label={<FormLabelUI text="Másolhat" />}
            disabled={!canEdit}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canDelete ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanDelete(value);
            }}
            option={options}
            label={<FormLabelUI text="Törölhet" />}
            disabled={!canEdit}
          />
        </div>
        <div className="mt-2 mx-2 w-2/5">
          <SelectUI
            value={canEmailSend ?? ''}
            onChange={(e) => {
              const value = e.target.value;
              setCanEmailSend(value);
            }}
            option={options}
            label={<FormLabelUI text="E-mail küldés" />}
            disabled={!canEdit}
          />
        </div>
      </div>
      <div className="px-4 mt-8 flex justify-center gap-3">
        <ButtonUI text="Hozzáadás" type="button" className="bg-success" onClick={handleChangeRole}>
          Mentés
        </ButtonUI>

        <ButtonUI text="Mégse" type="button" onClick={onHide} color="blue-gray" variant="gradient"></ButtonUI>
      </div>
    </DialogUI>
  );
};

export default DocRoleModify;
